<template>
    <div v-if="src" style="height: 100%;overflow: hidden;" v-loading="loading">
        <!-- <iframe :src="src" allowfullscreen="true" scrolling="auto" frameborder="0" style="width:100%;height:100%;" @load="onLoaded"></iframe> -->
    </div>
</template>
<script>
    import Vue from 'vue';
    import { SUPPLIER_URL } from '@/config';
    export default {
        data() {
            return {
                uri:SUPPLIER_URL+"/order/delivery",
                src:null,
                loading:false
            }
        },
        beforeRouteLeave(to, from, next) {
            this.src=null;
            next();
        },
        created() {
            console.log(this.$route.query)
            this.src=this.uri;
            if(this.$route.query.path && this.$route.query.path.length>0){
                this.src+=this.$route.query.path
            }
            // else{
            //     this.src+="center";
            // }
            if(this.src.indexOf('?')>=0){
                this.src+=("&token="+this.$store.state.loginUser.token+"&refresh_token="+this.$store.state.loginUser.refresh_token);
            }else{
                this.src+=("?token="+this.$store.state.loginUser.token+"&refresh_token="+this.$store.state.loginUser.refresh_token);
            }
        },
        methods: {
            onLoaded() {
                this.loading=false;
            }
        }
    }
</script>